export default __webpack_public_path__ + "static/media/404.4cc6ed3e.svg";